<template>
  <div class="bg">
    <div class="history-area">
      <history :newword="historyNewWord" :learnProgress="learnProgress" @clickHistoryWord="(w)=>clickHistoryWord(w)"></history>
    </div>
    <div class="wtop">
      <div class="wleft">
        <top-left :word="currentWord" :progress="wordProgress" :learnProgress="learnProgress" @progressChange="(n)=>wordProgress = n" :type="type" @wordOver="(n)=>writeState = n"></top-left>
      </div>
      <div class="wright">
        <top-right :words="words" :type="type"></top-right>
      </div>
    </div>
    <div class="wbottom">
      <div class="wleft">
        <bottom-left :word="currentWord" :progress="wordProgress" :type="type" :learnProgress="learnProgress"></bottom-left>
      </div>
      <div class="wright">
        <bottom-right :progress="wordProgress" :type="type" @progressChange="(n)=>wordProgress = n" @wordOver="wordOver"></bottom-right>
      </div>
    </div>
  </div>
</template>

<script>
import History from "./history-bar";
import TopLeft from "./top-left";
import TopRight from "./top-right";
import BottomLeft from "./bottom-left";
import BottomRight from "./bottom-right";

export default {
  props: ['unit','type'],
  components: {
    'history': History,
    'top-left': TopLeft,
    'top-right': TopRight,
    'bottom-left': BottomLeft,
    'bottom-right': BottomRight,
  },
  watch: {
    unit: function(n) {
      if (n!=null && n!={}) {
        this.initWord(n)
      }
    },
    words: function() {
      if (this.learnProgress.learnList!=null && this.learnProgress.learnList!=[]) {
        this.currentWord = this.learnProgress.learnList[this.learnProgress.current]
      }
    }
  },
  data() {
    return {
      baseApi: '/learn',
      currentUnit: {},
      words: [],
      learnProgress: {
        learnList: [],
        showCurrent: 0,
        current: 0,
        total: 0,
        know: [],
        unsure: [],
        miss: [],
      },
      wordProgress: 1,
      writeState: 3,
      currentWord: {},
      historyNewWord: null,
    }
  },
  created() {
  },
  methods: {
    initWord(unit) {
      this.$fly.post(`${this.baseApi}/init-word/${unit.id}`).then((res)=>{
        this.learnProgress.learnList = res;
        this.learnProgress.total = res.length;
        this.learnProgress.current = 0;
        this.learnProgress.showCurrent = 0;
        this.learnProgress.know = [];
        this.learnProgress.unsure = [];
        this.learnProgress.miss = [];
        this.words = res;
        this.progressChange();
      })
    },
    wordOver(state) {
      if (state == 0) {
        state = this.writeState
      }
      let inKnow = this.learnProgress.know.indexOf(this.currentWord)
      let inUnsure = this.learnProgress.unsure.indexOf(this.currentWord)
      let inMiss = this.learnProgress.miss.indexOf(this.currentWord)
      if (inKnow==-1 && inUnsure==-1 && inMiss==-1) {
        this.learnProgress.showCurrent++;
      }
      //加入相应的list
      if (state == 1) {
        //之前没有
        if (inKnow==-1 && inUnsure==-1 && inMiss==-1) {
          this.learnProgress.know.push(this.currentWord)
        }
      } else if (state == 2) {
        //之前不是unsure和miss
        if (inUnsure==-1 && inMiss==-1) {
          //之前是know
          if (inKnow != -1) {
            this.learnProgress.know.splice(inKnow,1)
          }
          this.learnProgress.learnList.splice(this.learnProgress.current+4<this.learnProgress.learnList.length-1?this.learnProgress.current+4:this.learnProgress.learnList.length-1, 0, this.currentWord);
          this.learnProgress.learnList.splice(this.learnProgress.current+2<this.learnProgress.learnList.length-1?this.learnProgress.current+2:this.learnProgress.learnList.length-1, 0, this.currentWord);
          this.learnProgress.learnList.splice(this.learnProgress.current+1<this.learnProgress.learnList.length-1?this.learnProgress.current+1:this.learnProgress.learnList.length-1, 0, this.currentWord);
          this.learnProgress.unsure.push(this.currentWord)
        }
      } else if (state == 3) {
        if (inMiss==-1) {
          //之前是know
          if (inKnow != -1) {
            this.learnProgress.know.splice(inKnow,1)
            this.learnProgress.learnList.splice(this.learnProgress.current+22<this.learnProgress.learnList.length-1?this.learnProgress.current+22:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+16<this.learnProgress.learnList.length-1?this.learnProgress.current+16:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+11<this.learnProgress.learnList.length-1?this.learnProgress.current+11:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+8<this.learnProgress.learnList.length-1?this.learnProgress.current+8:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+4<this.learnProgress.learnList.length-1?this.learnProgress.current+4:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+2<this.learnProgress.learnList.length-1?this.learnProgress.current+2:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+1<this.learnProgress.learnList.length-1?this.learnProgress.current+1:this.learnProgress.learnList.length-1, 0, this.currentWord);
          }
          //之前没有
          if (inKnow == -1 && inUnsure == -1) {
            this.learnProgress.learnList.splice(this.learnProgress.current+22<this.learnProgress.learnList.length-1?this.learnProgress.current+22:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+16<this.learnProgress.learnList.length-1?this.learnProgress.current+16:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+11<this.learnProgress.learnList.length-1?this.learnProgress.current+11:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+8<this.learnProgress.learnList.length-1?this.learnProgress.current+8:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+4<this.learnProgress.learnList.length-1?this.learnProgress.current+4:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+2<this.learnProgress.learnList.length-1?this.learnProgress.current+2:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+1<this.learnProgress.learnList.length-1?this.learnProgress.current+1:this.learnProgress.learnList.length-1, 0, this.currentWord);
          }
          //之前是unsure
          if (inUnsure != -1) {
            this.learnProgress.unsure.splice(inUnsure,1)
            this.learnProgress.learnList.splice(this.learnProgress.current+13<this.learnProgress.learnList.length-1?this.learnProgress.current+13:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+7<this.learnProgress.learnList.length-1?this.learnProgress.current+7:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+3<this.learnProgress.learnList.length-1?this.learnProgress.current+3:this.learnProgress.learnList.length-1, 0, this.currentWord);
            this.learnProgress.learnList.splice(this.learnProgress.current+1<this.learnProgress.learnList.length-1?this.learnProgress.current+1:this.learnProgress.learnList.length-1, 0, this.currentWord);
          }
          this.learnProgress.miss.push(this.currentWord)
        }
      }
      //加入历史记录
      this.historyNewWord = this.currentWord

      //结束单元
      if (this.learnProgress.current == this.learnProgress.learnList.length-1) {
        this.learnProgress.current = 0;
        this.learnProgress.showCurrent = 0;
        this.$emit('unitOver',{
          know: this.handleBookId(this.learnProgress.know),
          unsure: this.handleBookId(this.learnProgress.unsure),
          miss: this.handleBookId(this.learnProgress.miss),
        })
      } else {
        this.learnProgress.current++;
        
        this.currentWord = this.learnProgress.learnList[this.learnProgress.current];
        this.progressChange();
      }
    },
    handleBookId(list) {
      let li = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        li.push(item.wordNo);
      }
      return li;
    },
    progressChange() {
      this.$emit('progressChange',this.learnProgress)
    },
    clickHistoryWord(word) {
      this.learnProgress.learnList.splice(this.learnProgress.current,0,word);
    }
  },
}
</script>

<style scoped>
.bg{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 82vh;
  width: 100vw;
  overflow: hidden;
}
.history-area{
  height: 3em;
  background: #ffffff7e;
  margin: 0;
}
.wtop{
  height: 170px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.wbottom{
  margin: 15px 0 0 0;
  height: calc(100vh - 170px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.wleft{
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.wright{
  margin-left: 30px;
  width: 30%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
@media screen and (max-height: 1400px){
  .wtop{
    height: 150px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .wbottom{
    margin: 15px 0 200px 0;
    height: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
